module.exports = __webpack_public_path__ + "static/kcdc19-5186fac18bd300ca3ed6b840bf0aa94f.jpg";